<template>
  <div class="fade-in-text" ref="animationTitle" v-intersect="{ callback: handleIntersect, threshold: 0 }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() { },
  watch: {},
  methods: {
    handleIntersect(entry, observer) {
      this.animateText();
      observer.unobserve(entry.target);
    },
    animateText() {
      const texts = this.$refs.animationTitle;
      texts.classList.add("jump-animation");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
